<!-- The snackbar component has the ability to display one or more messages at the bottom of the UI (using v-bottom-sheet) -->
<!-- It is controlled by the snackbarStore. -->
<!-- Usage: dispatch a vuex action like this: dispatch('snackbar/displaySnackbar',{ action, text }) -->
<!--        action is an src/actions/Actions object (or one of the derived classes)
-->
<template>
  <transition name="slide">
    <div
        v-if="isOpen"
        :style="{ visibility: isOpen ? 'visible' : 'hidden'}"
        :class="theme.snackbar.bg"
        class="elevation-3 snackbar"
     
    >
      <div class="pa-4 caption" :class="theme.snackbar.text" v-html="text"></div>
    </div>
  </transition>
</template>

<script>
import {mapState} from 'vuex';
import common from '@/mixins/common';

export default {
  name: 'Snackbar',
  mixins: [common],

  computed: {
    ...mapState({
      text: (state) => state.snackbar.text,
    }),
    isOpen: {
      get() {
        return this.$store.state.snackbar.isOpen;
      },
      set(value) {
        if (value !== this.$store.state.snackbar.isOpen) {
          this.$store.commit('snackbar/setIsOpen', value);
        }
      },
    },
  },
};
</script>
<style scoped>
.snackbar {
  opacity: 0.97;
  border-radius: 20px;
  position: fixed;
  z-index: 10000000;
  top: 110px;
  right: 30px;
  max-width: 90vw;
}
</style>
